import styled from "styled-components";

export const DropdownWrapper = styled.div`
  width: 100%;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: rgb(240, 240, 240);
    cursor: pointer;
  }

  &:hover input {
    background-color: rgb(240, 240, 240);
    cursor: pointer;
  }
`;

export const DropdownOptions = styled.div`
  position: absolute;
  width: 100%;
  border: none;
  z-index: 4;
  margin-top: 4px;
  box-shadow: 0px 0px 5px #888888;
`;

export const DropdownOption = styled.div`
  padding: 10px;
  &:hover {
    background-color: #e1e1e1;
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row-reverse;

  & input {
    margin: 0px;
    outline: none;
  }
`;

export const DropdownChevron = styled.div`
  height: 48px;
  width: 32px;
  justify-content: center;
  align-items: center;
  display: flex;
  color: black;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  font-size: 14px;
`;

export const DropdownInput = styled.input`
  border: none;
  text-align: center;
  background-color: #f7f7f7;
  font-size: 14px;
  font-family: arial;
  color: black;
  font-weight: 400;
`;
